import type { SeasonModel } from "../../shared/types/contracts";

export function ScheduleSeasonFilter({
  seasons,
  activeSeasonId,
  selectedSeasonId,
  onChange,
}: {
  seasons: SeasonModel[];
  activeSeasonId: string | null;
  selectedSeasonId: string;
  onChange: (seasonId: string) => void;
}) {
  return (
    <label className="grid gap-1 text-sm font-bold">
      SEASON
      <select
        aria-label="Schedule season"
        value={selectedSeasonId}
        onChange={(event) => onChange(event.target.value)}
        className="h-10 rounded-[var(--radius-sm)] border border-input bg-surface px-3 text-sm text-foreground"
      >
        {seasons.map((season) => (
          <option key={season.id} value={season.id}>
            {season.label}
            {season.id === activeSeasonId ? " (active)" : ""}
          </option>
        ))}
      </select>
    </label>
  );
}
